import { render, staticRenderFns } from "./UpdateMobileEmail.vue?vue&type=template&id=681fd15e&scoped=true&"
import script from "./UpdateMobileEmail.vue?vue&type=script&lang=js&"
export * from "./UpdateMobileEmail.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMobileEmail.vue?vue&type=style&index=0&id=681fd15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681fd15e",
  null
  
)

export default component.exports